import { updateNextMeetingInformation } from '../actions/internalActions';
import getNextMeeting from '../selectors/getNextMeeting';
import { orchestrator } from 'satcheljs';
import { initializeUpNext } from '../actions/publicActions';
import { MINUTE_IN_MILLISECONDS } from '../utils/UpNextConstants';

orchestrator(initializeUpNext, actionMessage => {
    setInterval(() => {
        const nextMeeting = getNextMeeting();
        updateNextMeetingInformation(nextMeeting);
    }, MINUTE_IN_MILLISECONDS);
});
